import cx from 'classnames'

export const Label = ({ check = false, children, className, ...props }) => (
  <label className={cx(check ? 'tw:flex tw:items-start tw:gap-3' : 'ds-label tw:block', className)} {...props}>{children}</label>
)
